import React from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";

const ModalSaveAsDocOnline = ({
  showModalSaveAsDocOnline,
  setShowModalSaveAsDocOnline,
  docOnline,
  setDocOnline,
  submitButtonActionFunction,
  error,
  setError
}) => {
  const { t } = useTranslation();

  const onChangeDocOnline = ({ target }) => {
    let docOnlineCache = { ...docOnline };

    if (target.value) {
      docOnlineCache[target.name] = target.value;
      setError({});
    } else {
      docOnlineCache[target.name] = null;
      setError({ title: t("The title is required") });
    }
    setDocOnline(docOnlineCache);
  };

  return (
    <ModalContainer
      modalSubtitle={t(
        "Fill the title of the document to be saved and confirm"
      )}
      isOpen={showModalSaveAsDocOnline}
      submitButtonAction={submitButtonActionFunction}
      submitButtonTitle={t("Confirm")}
      submitButtonType="button"
      closeModal={() => setShowModalSaveAsDocOnline(false)}
      crossmarkAction={() => setShowModalSaveAsDocOnline(false)}
    >
      <div className="col-md-12">
        <div className="form-group">
          <div className="label-wrapper">
            <label>{t("Title")}</label>
            {error.title !== undefined && (
              <span className="error-msg">{t("The title is required")}</span>
            )}
          </div>
          <input
            className="input-field"
            type="text"
            placeholder=""
            id="title"
            name="title"
            onChange={onChangeDocOnline}
          />
        </div>
      </div>
    </ModalContainer>
  );
};

export default ModalSaveAsDocOnline;
